'use client';
import { useAvatars, useUser, useUserStoreActions } from '@/store';
import React, { useEffect } from 'react';

const SetRandomAvatarForNewUsers = () => {
	const user = useUser();
	const avatars = useAvatars();
	const { setRandomAvatar } = useUserStoreActions();
	useEffect(() => {
		if (user && avatars) {
			const randomIndex = Math.floor(Math.random() * avatars.length);
			setRandomAvatar(avatars[randomIndex]);
		}
	}, [user, avatars]);
	return null;
};

export default SetRandomAvatarForNewUsers;
